import TagManager from "react-gtm-module";

const claimDealGA = (eventAction, eventLabel) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "custom_event",
      event_category: "sales_show",
      event_action: eventAction,
      event_label: eventLabel
    }
  });
};

export default claimDealGA;
